module.exports = __webpack_public_path__ + "img/profile.a1215ee9.svg";